import $api from "../http";
import { IReferralSettings } from "../models/ReferralSettings";
import { IReferralMember } from "../models/ReferralMember";

class ReferralProgramServiceClass {
  async getReferralSettings() {
    return await $api.get<IReferralSettings>("/api/referral-settings");
  }

  async updateReferralSettings(id: string, model: { creditsReward: number }) {
    return await $api.put<boolean>(`/api/referral-settings/${id}`, model);
  }

  async getMembersWithPagination(currentPage: number | undefined, pageSize: number | undefined) {
    return await $api.get<{ members: IReferralMember[]; membersCount: number }>(
      `/api/referral-member/get-all/?currentPage=${currentPage}&pageSize=${pageSize}`
    );
  }
}

export const ReferralProgramService = new ReferralProgramServiceClass();
